/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type IngredientsSummaryList_summaryIngredient$ref = any;
type Recipe_recipe$ref = any;
export type SingleRecipePageRefetchQueryVariables = {|
  id: string
|};
export type SingleRecipePageRefetchQueryResponse = {|
  +recipe: ?{|
    +$fragmentRefs: Recipe_recipe$ref
  |},
  +summaryIngredient: ?{|
    +$fragmentRefs: IngredientsSummaryList_summaryIngredient$ref
  |},
  +allRecipeIngredients: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +comments: ?string,
        +ingredient: {|
          +id: string,
          +name: string,
        |},
        +unityF: ?{|
          +id: string
        |},
        +qty: ?string,
        +section: ?{|
          +id: string,
          +name: ?string,
        |},
      |}
    |}>
  |},
|};
export type SingleRecipePageRefetchQuery = {|
  variables: SingleRecipePageRefetchQueryVariables,
  response: SingleRecipePageRefetchQueryResponse,
|};
*/


/*
query SingleRecipePageRefetchQuery(
  $id: ID!
) {
  recipe(id: $id) {
    ...Recipe_recipe
    id
  }
  summaryIngredient: allRecipeIngredients(recipe: $id, ingredient: "summary") {
    ...IngredientsSummaryList_summaryIngredient
  }
  allRecipeIngredients(recipe: $id, orderBy: "id") {
    edges {
      node {
        id
        comments
        ingredient {
          id
          name
        }
        unityF {
          id
        }
        qty
        section {
          id
          name
        }
      }
    }
  }
}

fragment IngredientsSummaryList_summaryIngredient on RecipeIngredientNodeConnection {
  edges {
    node {
      ingredient {
        name
        id
      }
      id
    }
  }
}

fragment RecipeDetails_recipe on RecipeNode {
  id
  published
  publicDate
  author {
    username
    id
  }
  allergen {
    edges {
      node {
        id
        name
        icon
      }
    }
  }
}

fragment RecipeInfo_recipe on RecipeNode {
  isTrend
  name
  description
  category {
    name
    id
  }
  labels {
    edges {
      node {
        id
        name
      }
    }
  }
  mediaFiles {
    edges {
      node {
        id
        mediaUrl
      }
    }
  }
  medRatings
  totalRatings
  difficulty
  serves
  time
}

fragment Recipe_recipe on RecipeNode {
  id
  name
  published
  ...RecipeInfo_recipe
  ...RecipeDetails_recipe
  favoritedBy {
    edges {
      node {
        username
        id
      }
    }
  }
  ...StepsList_recipe
  labels {
    edges {
      node {
        id
        name
      }
    }
  }
  recipeingredientSet {
    edges {
      node {
        id
        comments
        ingredient {
          id
          name
        }
        unityF {
          id
        }
        qty
        section {
          id
          name
        }
        fraction
      }
    }
  }
  recipeallergen {
    edges {
      node {
        id
        allergen {
          id
          name
          icon
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...SectionsList_recipe
  mediaFiles {
    edges {
      node {
        id
        mediaUrl
      }
    }
  }
}

fragment SectionsList_recipe on RecipeNode {
  section {
    edges {
      node {
        id
        name
        recipe {
          name
          id
        }
        recipeingredientSet {
          edges {
            node {
              id
              comments
              ingredient {
                name
                id
              }
              unityF {
                id
              }
              unity
              qty
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment StepsList_recipe on RecipeNode {
  steps {
    edges {
      node {
        id
        ordered
        description
        time
        speed
        temperatureDegrees
        temperatureControl
        turbo
        isRobot
        waitingInstructions
        media
        warning {
          edges {
            node {
              id
              slugName
            }
          }
        }
        ingredient {
          id
          name
        }
        weight
        unit
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "Variable",
  "name": "recipe",
  "variableName": "id"
},
v3 = [
  {
    "kind": "Literal",
    "name": "ingredient",
    "value": "summary"
  },
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comments",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  (v4/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "IngredientNode",
  "kind": "LinkedField",
  "name": "ingredient",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "UnitMeasureNode",
  "kind": "LinkedField",
  "name": "unityF",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qty",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "RecipeSectionNode",
  "kind": "LinkedField",
  "name": "section",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "orderBy",
      "value": "id"
    },
    (v2/*: any*/)
  ],
  "concreteType": "RecipeIngredientNodeConnection",
  "kind": "LinkedField",
  "name": "allRecipeIngredients",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RecipeIngredientNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecipeIngredientNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v5/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v14 = [
  (v6/*: any*/),
  (v4/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "username",
    "storageKey": null
  },
  (v4/*: any*/)
],
v17 = [
  (v4/*: any*/),
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "icon",
    "storageKey": null
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "IngredientNode",
  "kind": "LinkedField",
  "name": "ingredient",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SingleRecipePageRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RecipeNode",
        "kind": "LinkedField",
        "name": "recipe",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Recipe_recipe"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "summaryIngredient",
        "args": (v3/*: any*/),
        "concreteType": "RecipeIngredientNodeConnection",
        "kind": "LinkedField",
        "name": "allRecipeIngredients",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IngredientsSummaryList_summaryIngredient"
          }
        ],
        "storageKey": null
      },
      (v12/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SingleRecipePageRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RecipeNode",
        "kind": "LinkedField",
        "name": "recipe",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "published",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTrend",
            "storageKey": null
          },
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeCategoryNode",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": (v14/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LabelNodeConnection",
            "kind": "LinkedField",
            "name": "labels",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LabelNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LabelNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeMediaNodeConnection",
            "kind": "LinkedField",
            "name": "mediaFiles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeMediaNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecipeMediaNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mediaUrl",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "medRatings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalRatings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "difficulty",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serves",
            "storageKey": null
          },
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AllergenNodeConnection",
            "kind": "LinkedField",
            "name": "allergen",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AllergenNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AllergenNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNodeConnection",
            "kind": "LinkedField",
            "name": "favoritedBy",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeStepNodeConnection",
            "kind": "LinkedField",
            "name": "steps",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeStepNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecipeStepNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ordered",
                        "storageKey": null
                      },
                      (v13/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "speed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "temperatureDegrees",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "temperatureControl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "turbo",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isRobot",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "waitingInstructions",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "media",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WarningNodeConnection",
                        "kind": "LinkedField",
                        "name": "warning",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WarningNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WarningNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "slugName",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "weight",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unit",
                        "storageKey": null
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              (v20/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": [],
            "handle": "connection",
            "key": "StepsList_steps",
            "kind": "LinkedHandle",
            "name": "steps"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeIngredientNodeConnection",
            "kind": "LinkedField",
            "name": "recipeingredientSet",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeIngredientNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecipeIngredientNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fraction",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeAllergenNodeConnection",
            "kind": "LinkedField",
            "name": "recipeallergen",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeAllergenNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecipeAllergenNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AllergenNode",
                        "kind": "LinkedField",
                        "name": "allergen",
                        "plural": false,
                        "selections": (v17/*: any*/),
                        "storageKey": null
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              (v20/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": [],
            "handle": "connection",
            "key": "allergens_recipeallergen",
            "kind": "LinkedHandle",
            "name": "recipeallergen"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeSectionNodeConnection",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeSectionNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecipeSectionNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RecipeNode",
                        "kind": "LinkedField",
                        "name": "recipe",
                        "plural": false,
                        "selections": (v14/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RecipeIngredientNodeConnection",
                        "kind": "LinkedField",
                        "name": "recipeingredientSet",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RecipeIngredientNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RecipeIngredientNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  (v21/*: any*/),
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "unity",
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              (v20/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": [],
            "handle": "connection",
            "key": "SectionsList_section",
            "kind": "LinkedHandle",
            "name": "section"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "summaryIngredient",
        "args": (v3/*: any*/),
        "concreteType": "RecipeIngredientNodeConnection",
        "kind": "LinkedField",
        "name": "allRecipeIngredients",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeIngredientNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeIngredientNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v12/*: any*/)
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "SingleRecipePageRefetchQuery",
    "operationKind": "query",
    "text": "query SingleRecipePageRefetchQuery(\n  $id: ID!\n) {\n  recipe(id: $id) {\n    ...Recipe_recipe\n    id\n  }\n  summaryIngredient: allRecipeIngredients(recipe: $id, ingredient: \"summary\") {\n    ...IngredientsSummaryList_summaryIngredient\n  }\n  allRecipeIngredients(recipe: $id, orderBy: \"id\") {\n    edges {\n      node {\n        id\n        comments\n        ingredient {\n          id\n          name\n        }\n        unityF {\n          id\n        }\n        qty\n        section {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n\nfragment IngredientsSummaryList_summaryIngredient on RecipeIngredientNodeConnection {\n  edges {\n    node {\n      ingredient {\n        name\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment RecipeDetails_recipe on RecipeNode {\n  id\n  published\n  publicDate\n  author {\n    username\n    id\n  }\n  allergen {\n    edges {\n      node {\n        id\n        name\n        icon\n      }\n    }\n  }\n}\n\nfragment RecipeInfo_recipe on RecipeNode {\n  isTrend\n  name\n  description\n  category {\n    name\n    id\n  }\n  labels {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  mediaFiles {\n    edges {\n      node {\n        id\n        mediaUrl\n      }\n    }\n  }\n  medRatings\n  totalRatings\n  difficulty\n  serves\n  time\n}\n\nfragment Recipe_recipe on RecipeNode {\n  id\n  name\n  published\n  ...RecipeInfo_recipe\n  ...RecipeDetails_recipe\n  favoritedBy {\n    edges {\n      node {\n        username\n        id\n      }\n    }\n  }\n  ...StepsList_recipe\n  labels {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  recipeingredientSet {\n    edges {\n      node {\n        id\n        comments\n        ingredient {\n          id\n          name\n        }\n        unityF {\n          id\n        }\n        qty\n        section {\n          id\n          name\n        }\n        fraction\n      }\n    }\n  }\n  recipeallergen {\n    edges {\n      node {\n        id\n        allergen {\n          id\n          name\n          icon\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...SectionsList_recipe\n  mediaFiles {\n    edges {\n      node {\n        id\n        mediaUrl\n      }\n    }\n  }\n}\n\nfragment SectionsList_recipe on RecipeNode {\n  section {\n    edges {\n      node {\n        id\n        name\n        recipe {\n          name\n          id\n        }\n        recipeingredientSet {\n          edges {\n            node {\n              id\n              comments\n              ingredient {\n                name\n                id\n              }\n              unityF {\n                id\n              }\n              unity\n              qty\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment StepsList_recipe on RecipeNode {\n  steps {\n    edges {\n      node {\n        id\n        ordered\n        description\n        time\n        speed\n        temperatureDegrees\n        temperatureControl\n        turbo\n        isRobot\n        waitingInstructions\n        media\n        warning {\n          edges {\n            node {\n              id\n              slugName\n            }\n          }\n        }\n        ingredient {\n          id\n          name\n        }\n        weight\n        unit\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8692287aa188c21d2cff98db92064d3d';

module.exports = node;
